export const TRIAL_EXCL_PLANS = ['trial-excl', 'trial-excl-evoost'] as const;

export type TrialExclPlan = (typeof TRIAL_EXCL_PLANS)[number];

export function isTrialExclPlan(plan?: string | null): plan is TrialExclPlan {
  return TRIAL_EXCL_PLANS.includes((plan || '') as TrialExclPlan);
}

export function isInternationalTrialExclPlan(plan?: string | null, code?: string | null, parentCode?: string | null) {
  const hasInternationalCode = [code, parentCode].some(
    (value) =>
      String(value || '')
        .trim()
        .toUpperCase() === 'INTERNATIONAL'
  );
  return isTrialExclPlan(plan) && hasInternationalCode;
}

export function isInternationalFreemiumAccess(plan?: string | null) {
  return isTrialExclPlan(plan);
}
